/**
 * TODO: [🔅] Put all %c styled console logs styles into one config place
 */

export const COLLDEV_SYNCER_STYLE = `background: #ff6622; color: black; font-size: 1.1em; font-weight: bold; padding: 5px; border-radius: 3px;`;
